<template>
    <div class="container container-large">
        <DeleteConfirmation></DeleteConfirmation>
        <div class="dashboard">
            <a class="dashboard--menu-toggle-btn collapsed" data-bs-toggle="collapse" href="#dashboardMenu">Menu</a>
            <StudentRightMenu></StudentRightMenu>
            <div class="dashboard--content">
                <div class="dashboard--main-box student-subaccount-box">
                    <div class="student-subaccount-box--title-container">
                        <h3 class="student-subaccount-box--title">
                            {{ $t('Sub Accounts Settings') }}
                        </h3>
                        <p class="student-subaccount-box--subtitle">
                            {{ $t('Your Kids accounts') }}
                        </p>
                    </div>
                    <div class="student-subaccount-box--add-student"><a style="cursor:pointer" class="btn-round auth-btn"
                            @click="showCreateForm()">{{ $t('Add a Kid') }}</a></div>
                    <div class="row">
                        <div class="col-xl-3 col-lg-4 col-sm-6" v-for="(n, index) in modelList">
                            <div class="student-subaccount-box--child-box">
                                <div class="student-subaccount-box--child-box-photo"><img class="img-fluid"
                                        :src="n.gender == 'Male' ? 'assets/images/boy.jpg' : 'assets/images/girl.jpg'"
                                        alt="child photo"></div>
                                <p class="student-subaccount-box--child-box-name">
                                    {{ n.first_name + ' ' + n.last_name }}
                                </p>
                                <p class="student-subaccount-box--child-box-passcode">
                                    @{{ $t('Passcode') }} |<span> {{ n.access_code }}</span>
                                </p>
                                <div class="student-subaccount-box--child-box-btn-container"><a
                                        class="btn-round auth-btn student-subaccount-box--child-box-btn"
                                        style="cursor:pointer" @click="showEditForm(n)">{{ $t('Edit') }}</a><a
                                        class="btn-round auth-btn student-subaccount-box--child-box-btn"
                                        style="cursor:pointer;" @click="showDeleteConfirm(n)">{{ $t('Delete') }}</a><a
                                        class="btn-round auth-btn student-subaccount-box--child-box-btn"
                                        style="cursor:pointer;" @click="GeneratePassCode(n)">Re-generate Passcode</a></div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-sm-12" style="text-align:center" v-if="modelList.length <= 0">
                            <p class="student-subaccount-box--subtitle">
                                {{ $t('thereisnokids') }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="modal fade add-edit--student-model" id="addEditModel">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-body">
                                <h3 class="add-edit--student-model--title">
                                    {{ isEdit ? $t(EditExistTitle) : $t(AddNewTitle) }}
                                </h3>
                                <p class="add-edit--student-model--form-title">
                                    {{ $t('FileData') }}:
                                </p>
                                <form>
                                    <div
                                        :class="{ 'form--group add-edit--student-model--form-group': true, 'form--error': showValidMessage && errors.has('first_name') }">
                                        <v-text-field v-bind:label="$t('First Name')" id="first_name" name="first_name"
                                            v-model="model.first_name" v-validate="'required|alpha'" maxlength="50">
                                        </v-text-field>
                                        <p v-show="showValidMessage && errors.has('first_name')" class="form--error-text">{{
                                            errors.first('first_name') }}</p>
                                    </div>
                                    <div
                                        :class="{ 'form--group add-edit--student-model--form-group': true, 'form--error': showValidMessage && errors.has('last_name') }">
                                        <v-text-field v-bind:label="$t('Last Name')" id="last_name" name="last_name"
                                            v-model="model.last_name" v-validate="'required|alpha'" maxlength="50">
                                        </v-text-field>
                                        <p v-show="showValidMessage && errors.has('last_name')" class="form--error-text">{{
                                            errors.first('last_name') }}</p>
                                    </div>
                                    <div
                                        v-bind:class="{ 'form--group add-edit--student-model--form-group': true, 'form--error': showValidMessage && date_of_birthError != '' }">
                                        <v-dialog ref="dateOfBirthDialog" v-model="birthDateModal"
                                            v-bind:return-value.sync="model.date_of_birth" presistent width="290px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="model.date_of_birth"
                                                    v-bind:label="$t('date_of_birth')" prepend-icon="mdi-calendar"
                                                    v-bind="attrs" v-on="on" width="300px" v-on:input="customValidate()"
                                                    name="birthdate" id="birthdate">
                                                </v-text-field>
                                                <p v-show="showValidMessage && date_of_birthError != ''"
                                                    class="form--error-text">
                                                    {{ $t(date_of_birthError) }}
                                                </p>
                                            </template>
                                            <v-date-picker v-model="model.date_of_birth" scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" v-on:click="birthDateModal = false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn text color="primary"
                                                    v-on:click="$refs.dateOfBirthDialog.save(model.date_of_birth)">
                                                    Ok
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </div>
                                    <p class="add-edit--student-model--form-title large-margin">
                                        {{ $t('Select Gender') }}
                                    </p>
                                    <div class="form-select-gender-container">
                                        <label class="form--custom-gender-radio">
                                            <input type="radio" name="gender" value="Female" v-model="model.gender"><span
                                                class="form--custom-gender-radio-container"><span
                                                    class="form--custom-gender-radio-photo"><img class="img-fluid"
                                                        src="assets/images/girl.jpg" alt="girl avatar"></span><span
                                                    class="form--custom-gender-radio-gender-type">{{ $t('Girl')
                                                    }}</span></span>
                                        </label>
                                        <label class="form--custom-gender-radio">
                                            <input type="radio" name="gender" value="Male" v-model="model.gender"><span
                                                class="form--custom-gender-radio-container"><span
                                                    class="form--custom-gender-radio-photo"><img class="img-fluid"
                                                        src="assets/images/boy.jpg" alt="girl avatar"></span><span
                                                    class="form--custom-gender-radio-gender-type">{{ $t('Boy')
                                                    }}</span></span>
                                        </label>
                                    </div>
                                    <button class="btn-round add-student-btn" type="button" @click="save">
                                        {{ isEdit ? $t('Save Changes') : $t('Add a Kid') }}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalMixin from '@/GlobalMixin.js'
import StudentRightMenu from '@/components/StudentRightMenu.vue'
import DeleteConfirmation from '@/components/DeleteConfirmation.vue'

export default {
    components: {
        StudentRightMenu,
        DeleteConfirmation
    },
    mixins: [GlobalMixin],
    data() {
        return {
            date_of_birthError: '',
            AddNewTitle: "Add new Kid",
            EditExistTitle: "Edit Exist Kid",
            insertUrl: process.env.VUE_APP_APIEndPoint + 'auth/kid/add/',
            queryUrl: process.env.VUE_APP_APIEndPoint + 'auth/kid/list/',
            updateUrl: process.env.VUE_APP_APIEndPoint + 'auth/kid/update/',
            deleteUrl: process.env.VUE_APP_APIEndPoint + 'auth/kid/delete/',
            GeneratePassCodeUrl: process.env.VUE_APP_APIEndPoint + 'auth/kid/update_password/',
            birthDateModal: false
        }
    },
    methods: {
        load: function () {
            var self = this;
            if (self.queryUrl && self.queryUrl != '') {
                self.ShowLoading();
                self.axios.post(self.queryUrl, {}, self.headers)
                    .then(function (res) {
                        self.modelList = res.data;
                    })
                    .catch(function (err) {
                        self.displayError(err);
                    }).finally(function () {
                        return self.HideLoading();
                    });
            }
        },
        GeneratePassCode(n) {
            let self = this;
            self.model = n;
            self.ShowLoading();
            let url = self.GeneratePassCodeUrl + self.model.id + "/"
            self.preUpdate();
            this.axios.post(url, self.model, self.headers)
                .then(function (res) {
                    /*if (res.data.success) {*/
                    self.load();
                    self.model = {};
                    //Slidepage();
                    //self.closeForm();
                    self.notify(self.successmsg, "success");
                    //}
                    //else {
                    //    self.notify(self.$t(res.data.Messages[0].Message), "error");
                    //}
                })
                .catch(function (err) {
                    self.displayError(err);
                    return console.log(err);
                }).finally(function () {
                    return self.HideLoading();
                })
        },
        createMode() {
            let self = this;
            self.model.gender = 'Male'
            self.model.register_type = 'kid'
        },
        customValidate: function () {
            let valid = true;
            let self = this;
            self.date_of_birthError = "";
            if (!self.model.date_of_birth) {
                self.date_of_birthError = "date_of_birthRequired";
                return false;
            }
            var age = self.calculate_age(self.model.date_of_birth)
            if (age < 4) {
                self.date_of_birthError = "date_of_birthlessthan4";
                return false;
            }
            return valid;
        },
        closeErrorAlert: function () {
            let self = this;
            self.date_of_birthError = "";
        },
        //    ,
        //    editMode() {
        //        let self = this;               
        //        self.model.register_type = 'kid'               
        //    }
    },
    created() {

    }
}
</script>
<style>
.form--error>div>div>div>input {
    border-color: #CE0E2D !important;
}
</style>